"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTypedData = void 0;
/**
 * Validates that `data` matches the EIP-712 JSON schema.
 *
 * @param {any} data
 * @return {boolean}
 */
var validateTypedData = function (data) {
    var typedData = data;
    // Validate that the data matches the EIP-712 JSON schema
    var valid = Boolean(typedData.types && typedData.primaryType && typedData.message);
    return valid;
};
exports.validateTypedData = validateTypedData;
